export const smoothScroll = (
  scrollContainer: HTMLElement,
  start: number,
  end: number,
  duration: number,
) => {
  let startTime: number | null = null

  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const progress = Math.min(timeElapsed / duration, 1)

    const easedProgress =
      progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2

    const currentPosition = start + (end - start) * easedProgress
    scrollContainer.scrollLeft = currentPosition

    if (timeElapsed < duration) {
      requestAnimationFrame(animation)
    }
  }

  requestAnimationFrame(animation)
}
